import { cn } from '@/lib/utils'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md', className)}
      style={{
        backgroundColor: 'var(--skeleton-bg)',
        borderRadius: 'var(--radius-md)',
      }}
      {...props}
    />
  )
}

export { Skeleton }

